function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", {
  id: "children_icon_svg__defs1559"
}, /*#__PURE__*/React.createElement("style", {
  id: "style1557"
}));
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.178 2.595c-.48-.919-2.145-.7-1.619.306.481.963 2.101.657 1.62-.306zm-.35-1.97a3.765 3.765 0 01.044.7 1.891 1.891 0 01.92.744 10.666 10.666 0 011.181.044A6.734 6.734 0 009.828.625zM5.276.187A8.744 8.744 0 018.34 1.37a1.835 1.835 0 01.7-.175 2.983 2.983 0 00-.087-.917 7.462 7.462 0 00-3.677-.09zm-5.252 7.4c1.532-2.582 4.858-4.114 7.616-4.99a1.545 1.545 0 01.131-.613 5.57 5.57 0 00-4.682-.79 7.008 7.008 0 00-3.065 6.39zm5.077 6.084c1.97-1.663 3.2-6.916 3.72-9.5a2.025 2.025 0 01-.919-.788c-2.845.92-6.609 2.582-7.572 5.6a6.935 6.935 0 004.771 4.685zm5.953-10.767a1.049 1.049 0 01-.088.613 8.578 8.578 0 012.67 5.427 6.9 6.9 0 00-.7-5.559c-.263-.396-1.27-.484-1.882-.484zm1.535 8.138c.744-2.714-.306-4.99-2.188-6.959a1.2 1.2 0 01-.788.22c-.525 2.713-1.663 7.44-3.545 9.541a6.925 6.925 0 006.521-2.802z",
  id: "children_icon_svg__path1565",
  fill: "currentColor",
  fillRule: "evenodd"
});
var SvgChildrenIcon = function SvgChildrenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.93,
    height: 13.905,
    id: "children_icon_svg__svg1569"
  }, props), _ref, _ref2);
};
export default SvgChildrenIcon;